import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// export default new Vuetify({});


import Logo from '@/components/Logo.vue'
import VKLogo from '@/components/VKLogo.vue'

export default new Vuetify({
    theme: { /**/ },
    icons: {
        values: {
            custom: { // name of our custom icon
                component: Logo, // our custom component
            },
            vk: { // name of our custom icon
                component: VKLogo, // our custom component
            },
        },
    },
})